(() => {
  function init() {
    const openButton = document.getElementById('brandDockMenu');
    const overlay = document.getElementById('brandOverlay');
    if (!openButton || !overlay || openButton.dataset.initialized) return;
    openButton.dataset.initialized = 'true';
    const closeButton = document.getElementById('brandOverlayClose');
    const panel = overlay.querySelector('[role="dialog"]');
    let previousOverflow = '';
    function close() {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      if (typeof removeTrapFocus === 'function') removeTrapFocus(openButton);
      else openButton.focus();
    }
    openButton.addEventListener('click', () => {
      previousOverflow = document.body.style.overflow;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (typeof trapFocus === 'function') trapFocus(panel, closeButton);
      else closeButton.focus();
    });
    closeButton.addEventListener('click', close);
    document.getElementById('brandOverlayBackdrop').addEventListener('click', close);
    document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    function updateCount(count) {
      if (!Number.isFinite(count)) return;
      document.querySelectorAll('[data-g241-cart-count]').forEach(badge => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    }
    let pending;
    function refreshCount() {
      if (pending) return pending;
      const root = window.Shopify?.routes?.root || '/';
      pending = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(response => response.ok ? response.json() : null)
        .then(cart => { if (cart) updateCount(cart.item_count); })
        .catch(() => {})
        .finally(() => { pending = null; });
      return pending;
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (Number.isFinite(event.cartData?.item_count)) updateCount(event.cartData.item_count);
        else return refreshCount();
      });
    }
    window.addEventListener('pageshow', event => { if (event.persisted) refreshCount(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
